module.exports = __webpack_public_path__ + "img/info-warning.f906c857.svg";